module.exports = __webpack_public_path__ + "img/facebook.8a00b43e.svg";